import { render } from "./Loader.vue?vue&type=template&id=27046611&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=27046611&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27046611"]])

export default __exports__